<template>
  <div class="navbar navbar-dark navbar-expand-lg py-1 navbar-static">
    <div class="container-fluid ps-1">
      <div class="navbar-brand">
        <router-link
          to="/home"
          class="d-inline-flex align-items-center"
          title="Home"
        >
          <img
            src="@/assets/img/logos/logo_mini.png"
            class="h-32px"
            alt="Logo"
          />
          <span class="ms-2 text-white fs-lg">
            Sistema de Relatório de Tickets
          </span>
        </router-link>
      </div>
      <div class="d-xl-none">
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-navigation"
          aria-expanded="true"
          title="Expandir/Recolher"
        >
          <i class="ph ph-list" />
        </button>
      </div>
      <div class="navbar-collapse collapse" id="navbar-navigation">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <div class="navbar-nav-link rounded">
              <label
                class="form-check form-switch form-check-reverse"
                title="Habilitar Projetos Inativos"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="!onlyProjectsActive"
                  @change="handleToggle"
                />
                <span class="form-check-label">Projetos Inativos</span>
              </label>
            </div>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Registros"
            >
              Registros
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/registers/tickets"
                class="dropdown-item"
                title="Tickets"
              >
                Tickets
              </router-link>
              <router-link
                to="/registers/tickets-link-clients"
                class="dropdown-item"
                title="Vinculação de Tickets"
              >
                Vinculação de Tickets
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Clientes"
            >
              Clientes
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/clients"
                class="dropdown-item"
                title="Lista de Clientes"
              >
                Lista de Clientes
              </router-link>
              <router-link
                to="/notifications/franchise"
                class="dropdown-item"
                title="Notificações de Franquia"
              >
                Notificações de Franquia
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Relatórios"
            >
              Relatórios
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/reports/monthly"
                class="dropdown-item"
                title="Mensal"
              >
                Mensal
              </router-link>
              <router-link
                to="/reports/accumulated"
                class="dropdown-item"
                title="Acumulado"
              >
                Acumulado
              </router-link>
              <router-link
                to="/reports/productivity"
                class="dropdown-item"
                title="Produtividade"
              >
                Produtividade
              </router-link>
            </div>
          </li>
          <li class="nav-item ms-xl-1">
            <router-link
              to="/billings"
              class="navbar-nav-link rounded"
              title="Faturamento"
            >
              Faturamento
            </router-link>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Administração"
            >
              Administração
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/admin/boards"
                class="dropdown-item"
                title="Quadros"
              >
                Quadros
              </router-link>
              <router-link
                to="/admin/users"
                class="dropdown-item"
                title="Usuários"
              >
                Usuários
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ user && user.name ? user.name : 'Usuário não identificado' }}
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <button class="dropdown-item" @click="logout" title="Sair">
                <i class="ph ph-sign-out me-2" />Sair
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PATHS from '@/router/routesMap'

export default {
  name: 'Navbar',

  computed: {
    ...mapGetters(['user', 'onlyProjectsActive']),
  },

  methods: {
    ...mapActions(['changeProjectActive']),

    handleToggle() {
      this.changeProjectActive()
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        localStorage.clear()
        this.$router.push(PATHS.SIGN_IN)
      })
    },
  },
}
</script>
